import React from 'react';
import { FaTruck, FaShieldAlt, FaHeart, FaPaw } from 'react-icons/fa';
import './Hero.scss';

// Type assertion for React Icons
const TruckIcon = FaTruck as React.ComponentType<{ className?: string }>;
const ShieldIcon = FaShieldAlt as React.ComponentType<{ className?: string }>;
const HeartIcon = FaHeart as React.ComponentType<{ className?: string }>;

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <video 
        className="hero-video" 
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/assets/movies/premium-pets.mp4" type="video/mp4" />
      </video>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-main">PREMIUM PETS</span>
            <span className="title-sub">MOBILE GROOMING</span>
          </h1>
          <p className="hero-tagline">Professional Grooming at Your Quality Care</p>
          
          
          {/* Feature Buttons */}
          <div className="hero-feature-buttons">
            <button className="btn-outline" aria-label="Learn about our mobile service">
              <TruckIcon className="btn-icon" aria-hidden="true" />
              Mobile Service
            </button>
            <button className="btn-outline" aria-label="Learn about our certified professionals">
              <ShieldIcon className="btn-icon" aria-hidden="true" />
              Certified Professionals
            </button>
            <button className="btn-outline" aria-label="Learn about our cage-free experience">
              <HeartIcon className="btn-icon" aria-hidden="true" />
              Cage-Free Experience
            </button>
          </div>
          
          <p className="hero-description">
            We bring professional pet grooming directly to your door. Our mobile service ensures your furry friend receives quality care in the comfort of familiar surroundings
          </p>
          
          {/* Buttons */}
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => scrollToSection('contact')} aria-label="Book an appointment">
              <span className="paw-icon" aria-hidden="true">{FaPaw({ size: 16 })}</span>
              Book Appointment
            </button>
            <button className="btn-secondary" onClick={() => scrollToSection('services')} aria-label="View our services">See Our Services</button>
          </div>
          
          {/* Rating */}
          <div className="hero-rating">
            <span className="stars">⭐⭐⭐⭐⭐</span>
            <span className="rating-text">5-Star Happy Pets</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
